import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import EmptyLoader from "../../../../../components/emptyLoader";
import Loader from "../../../../../components/loader";
import { notify } from "../../../../../redux/actions/snack";
import getColors from "../../../../../components/colors";
import V2SkillCards from "./v2SkillCards";
import { Pagination, Select, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { getGenAiSkills } from "../../../../../redux/actions/skill";
const ViewV2skills = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [skills, setSkills] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const initialPage = parseInt(queryParams.get("page")) || 1;
    setActivePage(initialPage);
    fetchSkills(initialPage);
  }, []);
  const fetchSkills = async (pageNumber) => {
    let data = { page: pageNumber };
    setLoading(true);
    let res = await dispatch(getGenAiSkills(data));
    console.log(res, "res");
    setSkills(res?.data?.data);
    setTotalCount(res?.data?.count || 0);
    setLoading(false);
  };

  const handlePageChange = async (pageNumber) => {
    setActivePage(pageNumber);
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("page", pageNumber.toString());
    history.push({ search: queryParams.toString() });
    await fetchSkills(pageNumber);
  };
  return (
    <div className="task-col-search">
      <div className="task-col">
        <div className="title-btn">
          <h1 className="title"> Agent Workflows</h1>
          {/* <div className="rt-btns">
            <button
              className="btn btn-primary btn-black"
              data-toggle="modal"
              data-target="#recordModal"
            >
              + Agent
            </button>
          </div> */}
        </div>

        <div id="scrollableDiv" className="scrollable tl-scroll">
          {loading ? (
            <Loader
              styles={{ width: "80px", margin: "auto" }}
              root={{ display: "flex" }}
            />
          ) : (
            <div>
              {!loading && !skills?.length ? (
                <div>
                  <EmptyLoader
                    style={{ width: "30%" }}
                    message="No Agents found"
                  />
                </div>
              ) : (
                <div>
                  {skills?.map((item, key) => (
                    <V2SkillCards
                      color={getColors(item.name)}
                      key={key}
                      skill={item}
                    />
                  ))}
                  <div className="template-flex">
                    <div className="template-box scrollable">
                      <Pagination
                        current={activePage}
                        pageSize={9}
                        total={totalCount}
                        onChange={handlePageChange}
                        hideOnSinglePage={false}
                        showSizeChanger={false}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewV2skills;
